import { TextField, TextFieldProps } from '@mui/material';
import { forwardRef } from 'react'; // Import memo
import { Controller, useFormContext } from 'react-hook-form';

type Props = TextFieldProps & {
  name: string;
  readonly?: boolean;
  InputProps?: TextFieldProps['InputProps'];
};

const RHFTextField = forwardRef<HTMLInputElement, Props>(
  ({ name, readonly, InputProps, ...others }, ref) => {
    const { control } = useFormContext();

    return (
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
          // @ts-ignore
          <TextField
            {...field}
            inputRef={ref}
            autoComplete='off'
            size='medium'
            variant='outlined'
            label={others.label}
            fullWidth
            error={!!error}
            helperText={error?.message}
            InputProps={{
              ...(InputProps || {}),
              sx: readonly
                ? { border: 'none', '& fieldset': { border: 'none' } }
                : undefined,
            }}
            {...others}
          />
        )}
      />
    );
  }
);

export default RHFTextField;
